/**
 * Generated runtime TestId mirror for frontend/src/pages/AssignmentDecisions.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AssignmentDecisionsTestIds = {
  assignmentDecisionsCount: "assignment-decisions-count",
  assignmentDecisionsPage: "assignment-decisions-page",
  btnBulkDecide: "btn-bulk-decide",
  btnCertify: "btn-certify",
  btnNextItem: "btn-next-item",
  btnPrevItem: "btn-prev-item",
  bulkBtnKeep: "bulk-btn-keep",
  bulkBtnRevoke: "bulk-btn-revoke",
  bulkBtnUndecided: "bulk-btn-undecided",
  cardTitleAllAssignments: "card-title-all-assignments",
  colAccessProfile: "col-access-profile",
  colDecision: "col-decision",
  inputBulkComment: "input-bulk-comment",
  btnKeep: (decision_id: string) => `btn-keep-${decision_id}`,
  btnKeepPrefix: () => "btn-keep-" as TestIdPrefix,
  btnRevoke: (decision_id: string) => `btn-revoke-${decision_id}`,
  btnRevokePrefix: () => "btn-revoke-" as TestIdPrefix,
  btnUndecided: (decision_id: string) => `btn-undecided-${decision_id}`,
  btnUndecidedPrefix: () => "btn-undecided-" as TestIdPrefix,
  decisionAccessProfile: (decision_id: string) => `decision-access-profile-${decision_id}`,
  decisionAccessProfilePrefix: () => "decision-access-profile-" as TestIdPrefix,
  decisionRow: (decision_id: string) => `decision-row-${decision_id}`,
  decisionRowPrefix: () => "decision-row-" as TestIdPrefix,
  decisionToggle: (decision_id: string) => `decision-toggle-${decision_id}`,
  decisionTogglePrefix: () => "decision-toggle-" as TestIdPrefix
} as const;
